import { render } from "./Statistiche.vue?vue&type=template&id=26b45eb8&scoped=true"
import script from "./Statistiche.vue?vue&type=script&lang=js"
export * from "./Statistiche.vue?vue&type=script&lang=js"

import "./Statistiche.vue?vue&type=style&index=0&id=26b45eb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b45eb8"]])

export default __exports__